__turbopack_context__.v({
  "lines-amount-0.5": "styles-module-scss-module__LmgVRW__lines-amount-0.5",
  "lines-amount-1": "styles-module-scss-module__LmgVRW__lines-amount-1",
  "lines-amount-3": "styles-module-scss-module__LmgVRW__lines-amount-3",
  "root": "styles-module-scss-module__LmgVRW__root",
  "scrollButton": "styles-module-scss-module__LmgVRW__scrollButton",
  "scrollButtonNext": "styles-module-scss-module__LmgVRW__scrollButtonNext",
  "scrollButtonPrev": "styles-module-scss-module__LmgVRW__scrollButtonPrev",
  "scrollContainer": "styles-module-scss-module__LmgVRW__scrollContainer",
  "scrollWrap": "styles-module-scss-module__LmgVRW__scrollWrap",
  "scrollWrap3D": "styles-module-scss-module__LmgVRW__scrollWrap3D",
  "tail": "styles-module-scss-module__LmgVRW__tail",
  "tournamentName": "styles-module-scss-module__LmgVRW__tournamentName",
});
